import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface StatCardProps {
  label: string;
  subLabel?: string;
  value: string;
  change?: string;
  changeType?: "positive" | "negative" | "neutral";
  icon: LucideIcon;
}

export default function StatCard({ label, subLabel, value, change, changeType = "neutral", icon: Icon }: StatCardProps) {
  return (
    <div className="bg-[#F8FAFC] rounded-lg p-4 border border-[#E2E8F0]">
      <div className="flex items-center justify-between mb-3">
        <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon className="w-4.5 h-4.5 text-primary" />
        </div>
      </div>
      <p className="text-xs font-medium text-[#A0AEC0] uppercase tracking-wide mb-1">{label}</p>
      {subLabel && <p className="text-xs text-[#A0AEC0] mb-1">{subLabel}</p>}
      <p className="text-xl font-semibold text-[#1A202C]">{value}</p>
      {change && (
        <p
          className={cn(
            "text-xs mt-1 font-medium",
            changeType === "positive" && "text-green-600",
            changeType === "negative" && "text-red-600",
            changeType === "neutral" && "text-[#A0AEC0]"
          )}
        >
          {change}
        </p>
      )}
    </div>
  );
}
